import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import lifecycle from 'recompose/lifecycle';
import { withFormik } from 'formik';
import { updateUser } from '../../../facades/eagle/user';
import reduce from 'lodash/reduce';
import isEmpty from 'lodash/isEmpty';
import omitBy from 'lodash/omitBy';
import isNil from 'lodash/isNil';
import { withUser, buildUser } from '../../data-providers/user';

/* eslint-disable no-console */
const withUpdateUser = compose(
  withUser,
  withFormik({
    mapPropsToValues: props => ({
      base: '',
      email: '',
      firstname: '',
      lastname: '',
      marketing_opt_in: false,
      password: null,
      password_confirmation: null
    }),
    handleSubmit: (values, actions) => {
      const props = actions.props;
      updateUser(values)
        .then((res) => {
          if (window) {
            window.scrollTo({ top: 0 });
          }
          props.setUser(buildUser(res));
          props.setSubmitted(true);
          setTimeout(() => {
            actions.setSubmitting(false);
            props.setSubmitted(false);
          }, 2000);
        })
        .catch(err => {
          props.setUser({ response: err });
          actions.setSubmitting(false);
          const errors = err.details.errors;
          const fieldErrors = reduce(errors[0].detail, (result, value, key) => {
            result[key] = value[0];
            return result;
          }, {});
          actions.setErrors(fieldErrors);
        });
    },
  }),
  withProps(props => {
    const isDirty = reduce(omitBy(props.values, isNil), (result, value, key) => {
      if (isEmpty(props.user) || result) {
        return result;
      }

      if (!isNil(props.user[key]) && props.user[key] !== value) {
        result = true;
      }

      switch (key) {
        case 'password':
        case 'password_confirmation':
          result = true;
          break;
      }

      return result;
    }, false);

    return {
      useAlert: true,
      isSubmitting: !isDirty || props.isSubmitting
    };
  }),
  lifecycle({
    componentDidUpdate(prevProps) {
      if (prevProps.user !== this.props.user) {
        const values = reduce(prevProps.values, (result, value, key) => {
          result[key] = this.props.user[key] || prevProps.values[key];
          return result;
        }, {});

        prevProps.setValues(values);
      }
    }
  })
);
/* eslint-enable no-console */

export default withUpdateUser;



// WEBPACK FOOTER //
// ./src/client/js/view/components/UserForm/withUpdateUser.js